export const POSITION = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  CENTER_LEFT: 'center-left',
  CENTER: 'center',
  CENTER_RIGHT: 'center-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
};

export const SCALE = {
  SCALE_TO_FILL: 'scale-to-fit',
  TILED: 'tiled'
}

export const DEFAULT_COLOR = { r: 255, g: 255, b: 255, a: 1 };

export const DEFAULT_MEDIA_PROPERTY = { 
  opacity: 100,
  color: DEFAULT_COLOR,
  scale: SCALE.SCALE_TO_FILL,
  position: POSITION.CENTER
};
